import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import './scss/NavHeader.css';
import { NavLinks } from '../NavLinks';
import { NavLinkGroup } from '../NavLinkGroup';

export interface NavHeaderProps {
  navRoutesEntries: any;
  selectedLocation?: string;
  planYearContext?: string;
}

export const NavHeader: FC<NavHeaderProps> = ({
  navRoutesEntries,
  selectedLocation,
  planYearContext,
}) => {

  const { t } = useTranslation('pages.sidebarNavigation');

  const navHeaderEntries = navRoutesEntries.map(([heading, routes]: [string, any], index: React.Key | null | undefined) => (
    <NavLinkGroup heading={t(heading)} key={index}>
      <NavLinks
        navRoutes={Object.values(routes)}
        selectedLocation={selectedLocation}
        planYearContext={planYearContext}
        mainLink={true}
      />
    </NavLinkGroup>
  ));

  return navHeaderEntries;
};
